module.exports = __webpack_public_path__ + "b7f488cac4ad3a33f656577870bb3309.png";